import React, { Fragment, useRef } from 'react';
import constants from '../../constants';
import { translate } from '../../Services/translation';

const NavigationItem = ({
    links = [],
    contentLink = null,
    level = 0,
    parentName = '',
    itemNumber = 0,
    onMenuOpen,
}) => {
    const menuRef = useRef(null);
    const menuIconRef = useRef(null);
    const toggleMenu = () => {
        menuRef.current.classList.toggle('navbar__menu--show');
        menuIconRef.current && menuIconRef.current.classList.toggle('navbar__icon--menu-open');
    };
    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const selectedClass = contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const target = contentLink && contentLink.attributes && contentLink.attributes.target ? contentLink.attributes.target : '_self';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;
    return (
        <Fragment>
            {!contentLink ? (
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    ref={menuIconRef}
                    onClick={toggleMenu}
                ></a>
            ) : (
                <Fragment>
                    {level === 1 && links.length > 0 ? (
                        <a
                            className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                                } ${additionClass || ''}`}
                            onClick={() => {
                                onMenuOpen(itemNumber);
                                toggleMenu();
                            } }
                        >
                            {contentLink.name}
                        </a>
                    ) : (
                        <a
                            className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                                } ${additionClass || ''}`}
                            href={contentLink.url || '#'} target={target}
                        >
                            {contentLink.name}
                            {contentLink.extraInfo && <small className="hide-for-large">{contentLink.extraInfo}</small>}
                        </a>
                    )}
                    {links.length > 0 && (
                        <i
                            className="navbar__icon--caret-right navbar__icon"
                            onClick={toggleMenu}
                        ></i>
                    )}
                    {contentLink.extraInfo && <div className="show-for-large">{contentLink.extraInfo}</div>}
                </Fragment>
            )}

            {links.length > 0 && (
                <ul className="navbar__menu no-list" ref={menuRef}>
                    <li
                        className="navbar__menu-header"
                        key={`navbar-header-level-${level}`}
                    >
                        {!contentLink ? (
                            <></>
                        ) : (
                            <Fragment>
                                <i
                                    className="navbar__icon--caret-left navbar__icon"
                                    onClick={toggleMenu}
                                ></i>
                                <span className="navbar__title" onClick={toggleMenu}>
                                    {parentName || translate('code.menu.text.mainmenu')}
                                </span>
                            </Fragment>
                        )}
                    </li>
                    {level === 2 && (
                        <li className="navbar__item navbar__item--all hide-for-large">
                            <a className="navbar__link" href={contentLink.url || '#'}>
                                    {`${translate('code.menu.text.viewall')}${contentLink.name.toLowerCase()}`}
                            </a>
                        </li>
                    )}
                    {links.length > 0 &&
                        links.map(
                            (link, i) => (
                                <Fragment key={`level-${i}`}>
                                    {hasNameOrChildren(link) &&
                                        <li
                                            className={`navbar__item ${link.open ? 'navbar__item--open' : ''
                                                } navbar__item--level-${level}`}
                                            key={link.url}
                                        >
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                                level={level + 1}
                                                itemNumber={i}
                                                parentName={contentLink?.name || ''}
                                                onMenuOpen={() => onMenuOpen(i)}
                                            />
                                        </li>
                                    }
                                </Fragment>
                            )                            
                        )}
                    {constants.topLinks &&
                        constants.topLinks.length > 0 &&
                        constants.topLinks.map((topLink, index) => (
                            <Fragment key={`top-link-${index}`}>
                                <a className='navbar__top-link hide-for-large' href={topLink.href}>
                                    {topLink.text}
                                </a>
                            </Fragment>
                        ))}
                </ul>
            )}
        </Fragment>
    );
};

export default NavigationItem;
